/* tslint:disable */
/* eslint-disable */
import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { WeatherApiConfiguration, WeatherApiConfigurationParams } from './weather-api-configuration';

import { AgroClimaticZoneService } from './services/agro-climatic-zone.service';
import { AlertService } from './services/alert.service';
import { JobService } from './services/job.service';
import { LogService } from './services/log.service';
import { MapService } from './services/map.service';
import { MetaService } from './services/meta.service';
import { ProviderService } from './services/provider.service';
import { RegionService } from './services/region.service';
import { ReportingService } from './services/reporting.service';
import { TilesService } from './services/tiles.service';
import { WeatherStationService } from './services/weather-station.service';
import { WeatherService } from './services/weather.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
   imports: [],
   exports: [],
   declarations: [],
   providers: [
      LogService,
      AgroClimaticZoneService,
      AlertService,
      JobService,
      MapService,
      MetaService,
      ProviderService,
      RegionService,
      ReportingService,
      TilesService,
      WeatherService,
      WeatherStationService,
      WeatherApiConfiguration
   ]
})
export class WeatherApiModule {
   static forRoot(params: WeatherApiConfigurationParams): ModuleWithProviders<WeatherApiModule> {
      return {
         ngModule: WeatherApiModule,
         providers: [
            {
               provide: WeatherApiConfiguration,
               useValue: params
            }
         ]
      };
   }

   constructor(@Optional() @SkipSelf() parentModule: WeatherApiModule, @Optional() http: HttpClient) {
      if (parentModule) {
         throw new Error('WeatherApiModule is already loaded. Import in your base AppModule only.');
      }
      if (!http) {
         throw new Error(
            'You need to import the HttpClientModule in your AppModule! \n' +
               'See also https://github.com/angular/angular/issues/20575'
         );
      }
   }
}
